export default __webpack_public_path__ + "static/media/calendar_icon.3c5e3bf1.svg";